import axios from 'axios';

import runtimeConfig from '@/common/runtime-config';

export function configAxios() {
  axios.defaults.baseURL = runtimeConfig.apiBaseUrl;
  axios.defaults.maxContentLength = Infinity;
  axios.defaults.maxBodyLength = Infinity;
}

const authAxios = axios.create({
  baseURL: runtimeConfig.apiAuthUrl,
  withCredentials: true,
  maxContentLength: Infinity,
  maxBodyLength: Infinity,
});

// Request: если есть токен — цепляем Bearer
const addAuthHeader = (config) => {
  const store = require('@/app/shared/state/index').default;
  const token = store.state.auth?.oidc?.accessToken;
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
};
const onRequestError = (error) => Promise.reject(error);

axios.interceptors.request.use(addAuthHeader, onRequestError);
authAxios.interceptors.request.use(addAuthHeader, onRequestError);

// Response: 401 → refresh → retry
axios.interceptors.response.use(
  (response) => response,
  (error) => handle401(error),
);
authAxios.interceptors.response.use(
  (response) => response,
  (error) => handle401(error),
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(({ resolve, reject }) => {
    if (error) reject(error);
    else resolve();
  });
  failedQueue = [];
};

function retryWithToken(request) {
  const store = require('@/app/shared/state/index').default;
  request.headers.Authorization = `Bearer ${store.state.auth.oidc.accessToken}`;
  return axios(request);
}

async function handle401(error) {
  const originalRequest = error.config;

  if (error.response?.status !== 401 || originalRequest._retry) return Promise.reject(error);

  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    }).then(() => retryWithToken(originalRequest));
  }

  originalRequest._retry = true;
  isRefreshing = true;

  const store = require('@/app/shared/state/index').default;

  try {
    await store.dispatch('auth/oidc/refresh');
    processQueue(null);
    return retryWithToken(originalRequest);
  } catch (refreshError) {
    processQueue(refreshError);
    store.dispatch('auth/oidc/logout');
    return Promise.reject(refreshError);
  } finally {
    isRefreshing = false;
  }
}

export { authAxios };
